"use client";

import { ApplyIsolationForConversion } from "@/components/audioPlayers/ApplyIsolationForConversion";
import { BigAudioPlayer } from "@/components/audioPlayers/BigAudioPlayer";
import { DownloadIsolation } from "@/components/audioPlayers/downloadAudio/DownloadIsolation";
import { SaveAudio } from "@/components/audioPlayers/SaveAudio";
import { IsolationConstructedNoDates, UserNoDates } from "@/types/types";
import { canUseLibrary } from "@/utils/subscriptionLevels/canUseLibrary";
import { getSubscriptionPlan } from "@/utils/subscriptionLevels/getSubscriptionPlan";

export function DoneIsolation({
  isolation,
  user,
}: {
  isolation: IsolationConstructedNoDates;
  user: UserNoDates;
}) {
  const subscriptionPlan = getSubscriptionPlan(user.stripeSubscriptionId);
  const canSaveIsolation =
    subscriptionPlan === null ? false : canUseLibrary(subscriptionPlan);

  const audioPlayerSource = isolation.outputSoundMp3!.presignedUrlPlay;

  return (
    <div className="flex items-center gap-x-3">
      <BigAudioPlayer
        source={audioPlayerSource}
        bigWaves={false}
        className="w-full"
        includePreviewText={false}
        filename={null}
      />

      <ApplyIsolationForConversion isolation={isolation} user={user} />

      {canSaveIsolation && (
        <SaveAudio
          type="isolation"
          entity={isolation}
          confirmOnUnsave={false}
        />
      )}
      <DownloadIsolation isolation={isolation} />
    </div>
  );
}
